module.exports = __webpack_public_path__ + "static/media/meta.e6192809.png";